import { http } from './http_service';

//Get list of email marketing document with paginate
export function listPageDocument(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedStatus:obj.selectedStatus,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/em/document/list-page`, {
        params:params
    });
}

//Get Single
export function singleDocument(id){
    return http().get(`/em/document/single/${id}`);
}

//Add one
export function addDocument(data){
    return http().post('/em/document/add', data)
}

//Update
export function updateDocument(id, data){
    return http().post(`/em/document/update/${id}`, data)
}

//Post Wizard data
export function wizardPost(data){
  return http().post('/em/wizard/post', data);
}



